export function configSetPreferredLanguage($translateProvider, rnLocaleCookieProvider, rnLocalPreferences) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // Look first to locale cookie for user's preferred language
  let preferredLocale = rnLocaleCookieProvider.getLocale();
  if (!preferredLocale) {
    // Fallback to local preferences with a default of US English
    preferredLocale = _.get(rnLocalPreferences(), 'general.locale', 'en-US');
  }

  $translateProvider.preferredLanguage(preferredLocale);
}

export function runSetLanguage($translate, rnLocale) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  rnLocale.getBestFit()
    .then(function(bestFitLocale) {
      $translate.use(bestFitLocale.value);
    });
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/l10n/l10n.run.js